import { createContext } from "react";
import type { FoldStep } from "~/components/ui/bottom-sheet";

export interface MapLayoutContextValue {
  /** Whether the layout has mounted and portal targets are available */
  mounted: boolean;
  /** Current sheet step */
  sheetStep: FoldStep | null;
  /** Set sheet step directly */
  setSheetStep: (step: FoldStep | null) => void;
}

export const MapLayoutContext = createContext<MapLayoutContextValue | null>(null);
